import React from "react";
import { useId } from "react";
import { useQuery } from "seed/gql";
import { Loading } from "seed/helpers";
import l from "components/util/l";

const PermissionGridField = ({
  flowId,
  onlyAdminRoles,
  fields,
  values,
  setFieldValue,
  setValues
}) => {

  const fieldKey = useId();

  const onToggleColumn = (roleLabel) => {
    const isAllChecked = fields.every(field => values[field.name]?.[roleLabel]);
    const nextValues = { ...values };
    fields.forEach(field => {
      nextValues[field.name] = { ...(values[field.name] || {}), [roleLabel]: !isAllChecked };
    });
    setValues(nextValues);
  }

  // Follows the switches' own rules: a role whose parent permission is off cannot be granted, and
  // turning a permission off turns off the ones that depend on it.
  const onToggleRow = (field, roleLabels) => {
    const enabledRoles = roleLabels.filter(role => !field.parent || values[field.parent]?.[role]);
    const isAllChecked = enabledRoles.every(role => values[field.name]?.[role]);
    const nextValues = { ...values, [field.name]: { ...values[field.name] } };
    enabledRoles.forEach(role => { nextValues[field.name][role] = !isAllChecked; });
    if (isAllChecked && field.dependancies) {
      field.dependancies.forEach(dep => {
        nextValues[dep] = { ...values[dep] };
        enabledRoles.forEach(role => { nextValues[dep][role] = false; });
      });
    }
    setValues(nextValues);
  }

  let rolesFilter = `flow.id=${flowId}`;
  if (onlyAdminRoles != null)
    rolesFilter += ` AND is_admin=${onlyAdminRoles ? 'true' : 'false'}`;

  const reqRoles = useQuery(`{
    participantRoles {
      id
      name
    }
  }`, rolesFilter);

  if (reqRoles.loading) return <Loading />;
  if (reqRoles.error) return "Error";

  const { participantRoles = [] } = reqRoles.data;
  const permissions = participantRoles.map(role => ({
    key: role.id,
    label: role.name
  }));

  return (
    <div className="form-group mb-4">
      <div style={{ overflowX: 'auto' }}>
        <table className="table table-sm table-borderless table-hover mb-0">
          <thead>
            <tr>
              <th style={{ position: 'sticky', left: 0, zIndex: 1 }}>
              </th>
              {permissions.map(permission => (
                <th
                  key={fieldKey + permission.key}
                  className="text-center px-2"
                  style={{ cursor: 'pointer', userSelect: 'none' }}
                  title={l("Activar o desactivar todo%PA894")}
                  onClick={() => onToggleColumn(permission.label)}
                >
                  {permission.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {fields.map(field => (
              <React.Fragment key={fieldKey + field.name}>
                {field.separator &&
                  <tr style={{ pointerEvents: 'none', backgroundColor: 'transparent' }}>
                    <td colSpan={permissions.length + 1} className="pt-4 pb-1 border-0">
                      <hr className="mt-1 mb-2" />
                      <label className="dropdown-header px-0 mb-0 text-dark">{field.separator}</label>
                    </td>
                  </tr>}
                <tr>
                <td
                  style={{
                    position: 'sticky',
                    left: 0,
                    zIndex: 3,
                    whiteSpace: 'nowrap',
                  }}
                >
                  <span
                    style={{ cursor: 'pointer', userSelect: 'none' }}
                    title={l("Activar o desactivar todo%PA894")}
                    onClick={() => onToggleRow(field, permissions.map(permission => permission.label))}
                  >
                    {field.label}
                  </span>
                  {field.onEdit &&
                    <button
                      type="button"
                      className="btn btn-link btn-sm text-primary p-0 ml-3 align-baseline"
                      title={field.editTitle}
                      onClick={field.onEdit}
                    >
                      <i className="fas fa-pen" style={{ fontSize: '0.75rem' }}></i>
                    </button>}
                  {field.onDelete &&
                    <button
                      type="button"
                      className="btn btn-link btn-sm text-danger p-0 ml-3 align-baseline"
                      title={field.deleteTitle}
                      onClick={field.onDelete}
                    >
                      <i className="fas fa-trash-alt" style={{ fontSize: '0.75rem' }}></i>
                    </button>}
                </td>
                {permissions.map(permission => (
                  <td key={`${fieldKey}-${field.name}-${permission.key}`} className="text-center">
                    <div className="custom-control custom-switch">
                      <input
                        type="checkbox"
                        id={`${fieldKey}-${field.name}-${permission.key}`}
                        className="custom-control-input"
                        checked={values[field.name]?.[permission.label] || false}
                        disabled={field.parent && !values[field.parent]?.[permission.label]}
                        onChange={() => {

                          const newValues = values[field.name] || {};
                          newValues[permission.label] = !newValues[permission.label];
                          setFieldValue(field.name, newValues);

                          if (field.dependancies && newValues[permission.label] === false) {
                            field.dependancies.forEach(dep => {
                              const depValues = values[dep] || {};
                              if (depValues[permission.label]) {
                                depValues[permission.label] = false;
                                setFieldValue(dep, depValues);
                              }
                            });
                          }

                        }}
                      />
                      <label className="custom-control-label" htmlFor={`${fieldKey}-${field.name}-${permission.key}`}></label>
                    </div>
                  </td>
                ))}
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );


}

export default PermissionGridField;